import { Search } from "@mui/icons-material"
import { Box, Button, IconButton, InputBase, Paper, Stack, Tooltip } from "@mui/material"
import { DataGrid, GridColDef, GridValueGetterParams } from '@mui/x-data-grid';
import { useAppSelector } from "../../redux/hooks"
import { FACILITY_VERIFICATION_STAGE, PROVIDER_VERIFICATION_STAGE } from "../../shared/interfaces/users/user.interface";
import "./Dashboard.scss"
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
interface DashboardSearchPropTypes {

}

const DashboardProviderSearch = (props: DashboardSearchPropTypes) => {
    const session_data = useAppSelector(state => state.session_data)

    return (
        <>
            <div className="dashboardSearch muiInputWrapper">
                <h3 style={{margin: 0}}>Providers</h3>

                {/* DecorativeCircles Left */}
                <div className="dashboardSearchCircle"
                    style={{
                        top: "113px",
                        left: "52px",
                        width: "calc(202px / 1.5)",
                        height: "calc(202px / 1.5)",
                        transform: "scale(1.5)"
                    }}
                />
                <div className="dashboardSearchCircle"
                    style={{
                        top: "59px",
                        left: "-7.6px",
                        width: "calc(242px / 1.5)",
                        height: "calc(242px / 1.5)",
                        transform: "scale(1.5)"
                    }}
                />
                <div className="dashboardSearchCircle"
                    style={{
                        top: "11.94px",
                        left: "-55.5px",
                        width: "calc(275px / 1.5)",
                        height: "calc(275px / 1.5)",
                        transform: "scale(1.5)"
                    }}
                />
                <div className="dashboardSearchCircle"
                    style={{
                        top: "-53px",
                        left: "-125px",
                        width: "calc(327px / 1.5)",
                        height: "calc(327px / 1.5)",
                        transform: "scale(1.5)"
                    }}
                />

                {/* DecorativeCircles Right */}
                <div className="dashboardSearchCircle"
                    style={{
                        top: "calc(-334px / 1.5)",
                        right: "calc(-254px / 1.5)",
                        width: "calc(461px / 1.5)",
                        height: "calc(461px / 1.5)",
                        transform: "scale(1.5)"
                    }}
                />
                <div className="dashboardSearchCircle"
                    style={{
                        top: "calc(-216px / 1.5)",
                        right: "calc(-253px / 1.5)",
                        width: "calc(388px / 1.5)",
                        height: "calc(388px / 1.5)",
                        transform: "scale(1.5)"
                    }}
                />
            </div>
        </>
    )

}

export default DashboardProviderSearch